import { render, staticRenderFns } from "./ExternalSignerImport.vue?vue&type=template&id=872c1ec2&scoped=true&"
import script from "./ExternalSignerImport.vue?vue&type=script&lang=js&"
export * from "./ExternalSignerImport.vue?vue&type=script&lang=js&"
import style0 from "./ExternalSignerImport.vue?vue&type=style&index=0&id=872c1ec2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "872c1ec2",
  null
  
)

export default component.exports